/// <amd-module name="TFS/Admin/Views/ProfileSettings/TimeAndLocaleView/Sources/TimeAndLocaleViewSource" />
import { getUserClient } from "TFS/Admin/Common/RestClient/User"
import { IVssComponentContext } from "VSS/Platform/Layout";
import { UserAttribute, SetUserAttributeParameters} from "TFS/Admin/Common/Contracts/User"
import { IVssRestClientOptions } from "VSS/Platform/Context"

export class TimeAndLocaleViewSource {
    private _options: IVssRestClientOptions = {};

    constructor(options: IVssRestClientOptions) {
            this._options = options;
    }

    public setAttributes(attributeParametersList: SetUserAttributeParameters[], descriptor: string, context: IVssComponentContext): Promise<UserAttribute[]> {
        var restClient = this.getUserClient(context);
        return restClient.setAttributes(attributeParametersList, descriptor);
    }

    public getUserClient(context: IVssComponentContext) {
        return getUserClient(context.pageContext, this._options);
    }
}
